<template>
  <div>
    <label for="vinculo" class="required">Vínculo:</label>
    <select v-model="selectedVinculo" @change="enviarEmit" id="vinculo">
      <option v-for="v in vinculos" :key="v.id" :value="v.descricao">
        {{ v.descricao }}
      </option>
    </select>
  </div>
</template>
  
<script>
export default {
  name: 'Vinculo',
  emits: ['vinculo-selecionado'],
  props: {
    vinculo: {type: String, required: true}
  },

  data() {
    return {
      vinculos: [],
      selectedVinculo: this.vinculo
    };
  },

  watch: {
    selectedVinculo(newValue) {
      this.selectedVinculo = newValue;
    },

    vinculo(newValue) {
      this.selectedVinculo = newValue;
    }
  },

  methods: {

    async getVinculos() {
      try {
          const path = '/vinculo';
          const response = await this.$axios.get(path);
          this.vinculos = response.data;
      } catch (error) {
          if (error.response) {
              console.error('(buscando critérios) Resposta do servidor com status:', error.response.status);
          } else {
              console.error('(buscando critérios) Erro sem resposta do servidor:', error.message);
          }
      }

    },

    enviarEmit() {
      this.$emit('vinculo-selecionado', this.selectedVinculo);
    },
  },

  mounted() {
    this.getVinculos();
  },

};
</script>
  
<style scoped>
/* Adicione estilos específicos para o componente aqui, se necessário */
</style>